import { ViewOrUpdatePaymentMethodsCTA, ViewPaidInvoicesCTA } from "./ctas";
export var ManageBillToAddressIA = function ManageBillToAddressIA(strictLocalize) {
  return {
    titleBuilder: function titleBuilder(context) {
      return getAnswer(context, strictLocalize).getTitle();
    },
    descriptionBuilder: function descriptionBuilder(context) {
      return getAnswer(context, strictLocalize).getDescription();
    },
    primaryCtaBuilder: {
      textBuilder: function textBuilder(context) {
        var _getPrimaryCTA;
        return (_getPrimaryCTA = getPrimaryCTA(context, strictLocalize)) === null || _getPrimaryCTA === void 0 ? void 0 : _getPrimaryCTA.label;
      },
      linkBuilder: function linkBuilder(context) {
        var _getPrimaryCTA2, _getPrimaryCTA2$getLi;
        return (_getPrimaryCTA2 = getPrimaryCTA(context, strictLocalize)) === null || _getPrimaryCTA2 === void 0 ? void 0 : (_getPrimaryCTA2$getLi = _getPrimaryCTA2.getLink) === null || _getPrimaryCTA2$getLi === void 0 ? void 0 : _getPrimaryCTA2$getLi.call(_getPrimaryCTA2);
      }
    },
    secondaryCtaBuilder: {
      textBuilder: function textBuilder(context) {
        var _getSecondaryCTA;
        return (_getSecondaryCTA = getSecondaryCTA(context, strictLocalize)) === null || _getSecondaryCTA === void 0 ? void 0 : _getSecondaryCTA.label;
      },
      linkBuilder: function linkBuilder(context) {
        var _getSecondaryCTA2, _getSecondaryCTA2$get;
        return (_getSecondaryCTA2 = getSecondaryCTA(context, strictLocalize)) === null || _getSecondaryCTA2 === void 0 ? void 0 : (_getSecondaryCTA2$get = _getSecondaryCTA2.getLink) === null || _getSecondaryCTA2$get === void 0 ? void 0 : _getSecondaryCTA2$get.call(_getSecondaryCTA2);
      }
    }
  };
};
var getAnswer = function getAnswer(_context, strictLocalize) {
  return {
    getTitle: function getTitle() {
      return MANAGE_BILL_TO_ADDRESS(strictLocalize);
    },
    getDescription: function getDescription() {
      return [TO_CHANGE_BILL_TO_ADDRESS_ON_PAID_INVOICES(strictLocalize), TO_CHANGE_BILL_TO_ADDRESS_ON_UNPAID_INVOICES(strictLocalize)];
    }
  };
};
var getPrimaryCTA = function getPrimaryCTA(_context, strictLocalize) {
  return ViewPaidInvoicesCTA(strictLocalize);
};
var getSecondaryCTA = function getSecondaryCTA(_context, strictLocalize) {
  return ViewOrUpdatePaymentMethodsCTA(strictLocalize);
};
var MANAGE_BILL_TO_ADDRESS = function MANAGE_BILL_TO_ADDRESS(strictLocalize) {
  return strictLocalize({
    id: "RB21Bl",
    defaultMessage: [{
      "type": 0,
      "value": "Gerir o endereço do campo \"Faturar a\""
    }]
  });
};
var TO_CHANGE_BILL_TO_ADDRESS_ON_PAID_INVOICES = function TO_CHANGE_BILL_TO_ADDRESS_ON_PAID_INVOICES(strictLocalize) {
  return strictLocalize({
    id: "NRpOYg",
    defaultMessage: [{
      "type": 0,
      "value": "Para alterar o endereço do campo \"Faturar a\" nas faturas pagas, aceda à fatura que pretende atualizar e escolha \"Editar endereço\". Pode selecionar um dos endereços utilizados anteriormente ou adicionar um novo endereço para incluir na fatura. Se modificar faturas pagas, tem de editar cada uma individualmente. Se fizer alterações, o endereço de faturação associado à sua forma de pagamento não é afetado."
    }]
  });
};
var TO_CHANGE_BILL_TO_ADDRESS_ON_UNPAID_INVOICES = function TO_CHANGE_BILL_TO_ADDRESS_ON_UNPAID_INVOICES(strictLocalize) {
  return strictLocalize({
    id: "To1QTr",
    defaultMessage: [{
      "type": 0,
      "value": "Para alterar o endereço do campo \"Faturar a\" nas faturas não pagas, tem de alterar o endereço de faturação da forma de pagamento associada à fatura. Para atualizar, aceda a \"Formas de pagamento\" nas \"Definições de conta\" e encontre a forma de pagamento que pretende alterar. Selecione \"Editar\" junto do endereço de faturação e selecione um dos endereços utilizados anteriormente ou adicione um novo."
    }]
  });
};